import React from 'react'
import styled from '@emotion/styled'

type WithChildren<T = {}> = T & { children?: React.ReactNode }

const Content = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

export function CenteredHorizontalFlex({ children }: WithChildren) {
  return <Content>
    {children}
  </Content>
}
